<template>
  <a-layout class='index animated fadeIn'>
    <a-card>
      <a-form ref="ruleForm" :model="form" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-item label="银行账户开户银行所在省份编码:">
              {{form.prov_code}}
        </a-form-item>
        <a-form-item label="银行账户开户银行所在区域编码:">
              {{form.area_code}}
        </a-form-item>
        <a-form-item label="银行账户类型:">
            {{form.bank_acct_type==1?'公立账户':'私立账户'}}
        </a-form-item>
        <a-form-item label="银行卡号:">
            {{form.card_id}}
        </a-form-item>
        <a-form-item label="银行卡对应的户名:">
            {{form.card_name}}
        </a-form-item>
        <a-form-item label="手机号:">
            {{form.tel_no}}
        </a-form-item>
      </a-form>
    </a-card>
  </a-layout>
</template>
<script>
import { ref,reactive, toRefs} from "vue";
import { getBlankConfig } from "@/api/system";
export default {
  setup() {
    //pass
    const form = ref({ });
    const state = reactive({
      labelCol: { span:4 },
      wrapperCol: { span:14 },
    });
    const ruleForm = ref();
    // 获取基础设置
    const initData = async () => {
      let result = await getBlankConfig()
        .then((res) => res.data)
        .catch((error) => error);
      form.value = result.data;
    };
    initData();

    return {
      form,
      ...toRefs(state),
      ruleForm,
    };
  },
};
</script>
